import projectOptions from "src/shared/project-options";
const isSizeVariant = (attributeKey: string) => {
  const { variantKeys } = projectOptions.default.options;
  const _attributeKey = attributeKey.toLowerCase();

  const isSizeVariant =
    _attributeKey.includes(variantKeys?.size) ||
    _attributeKey.includes("beden") ||
    _attributeKey.includes("size");

  return isSizeVariant;
};

export default isSizeVariant;
